import { Link } from 'react-router-dom';
import api from '../../services/api';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';

function Relatorio() {

    const handleMercadoria = async () => {
        try {
            const response = await api.get(`/relatorio/mercadoria/pdf`, {
                responseType: 'blob',
            });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
        } catch (error) {
            console.error('Erro ao gerar o relatório PDF:', error);
        }
    };

    return (
        <PageContainer>
            <PageHeader title="Relatórios" />

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardActionArea component={Link} to="/relatorio/veiculo" sx={{ p: 3 }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                <DirectionsCarOutlinedIcon color="primary" sx={{ fontSize: 40 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, textAlign: 'center' }}>
                                    Relatório de veículo
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardActionArea onClick={handleMercadoria} sx={{ p: 3 }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                <PictureAsPdfOutlinedIcon color="secondary" sx={{ fontSize: 40 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, textAlign: 'center' }}>
                                    Resumo de Mercadorias (PDF)
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </PageContainer>
    );
}

export default Relatorio;
